// extracted by mini-css-extract-plugin
export default {"footerBg":"I-z","footerTopLinks":"J-z","footerFeedback":"K-z","footerSocial":"L-z","footerLegalLinks":"M-z","footerIconCards":"N-z","footerBotCopy":"O-z"};